import moment from 'moment'
import { Timeline, TimelineProps } from 'antd'

import { ICardContractTabLogs } from './types'
import { IContractCardLogs } from '@api/contracts/state.types'

import { Empty, Flex } from '@ui/index'
import imgEmty from '@img/empty.svg'
import { IconClock } from '@img/icons'


const getSiteName = (value: string) => {
    switch (value) {
        case 'modern_academy': return 'Современная Академия'
        case 'yaskill': return 'ЯСкилл'
        default: return value || '----'
    }
}

const getChangedField = (isVisible: boolean, label: string, value: string | number) => {
    if (!isVisible) return null

    return <p key={label}>{label} 👉 {value || '----'}</p>
}

const getActions = (previousItem: IContractCardLogs | undefined, currentItem: IContractCardLogs) => {
    if (!previousItem) {
        return <>
            <p>Изменения сохранены в карточке договора</p>
            <p>Нажата кнопка сохранить</p>
        </>
    }

    const rows = [
        getChangedField(previousItem.dataBaseName !== currentItem.dataBaseName, 'БД сайта', getSiteName(currentItem.dataBaseName)),
        getChangedField(previousItem.applicationID !== currentItem.applicationID, '№ заявки', currentItem.applicationID),
        getChangedField(previousItem.contractDate !== currentItem.contractDate, 'Дата договора', currentItem.contractDate),
        getChangedField(previousItem.contractNumber !== currentItem.contractNumber, 'Номер договора', currentItem.contractNumber),
        getChangedField(previousItem.contractTypeName !== currentItem.contractTypeName, 'Тип договора', currentItem.contractTypeName),
        getChangedField(previousItem.contractViewName !== currentItem.contractViewName, 'Вид договора', currentItem.contractViewName),
        getChangedField(previousItem.contractStatusName !== currentItem.contractStatusName, 'Статус договора', currentItem.contractStatusName),
        getChangedField(previousItem.companyNameShort !== currentItem.companyNameShort, 'Контрагент', currentItem.companyNameShort),
        getChangedField(previousItem.companyContactFIO !== currentItem.companyContactFIO, 'Контактное лицо', currentItem.companyContactFIO),
        getChangedField(previousItem.companyContactPhone !== currentItem.companyContactPhone, 'Телефон контактного лица', currentItem.companyContactPhone),
        getChangedField(previousItem.companyContactEmail !== currentItem.companyContactEmail, 'Email контактного лица', currentItem.companyContactEmail),
        getChangedField(previousItem.isGuardianRequired !== currentItem.isGuardianRequired, 'Данные родителя (опекуна) обязательны', currentItem.isGuardianRequired),
        getChangedField(previousItem.guardianBirthDate !== currentItem.guardianBirthDate, 'Дата рождения родителя (опекуна)', currentItem.guardianBirthDate),
        getChangedField(previousItem.guardianLastName !== currentItem.guardianLastName, 'Фамилия родителя (опекуна)', currentItem.guardianLastName),
        getChangedField(previousItem.guardianFirstName !== currentItem.guardianFirstName, 'Имя родителя (опекуна)', currentItem.guardianFirstName),
        getChangedField(previousItem.guardianSecondName !== currentItem.guardianSecondName, 'Отчество родителя (опекуна)', currentItem.guardianSecondName),
        getChangedField(previousItem.guardianPassport !== currentItem.guardianPassport, 'Паспортные данные родителя (опекуна)', currentItem.guardianPassport),
        getChangedField(previousItem.guardianRegistrationAddress !== currentItem.guardianRegistrationAddress, 'Адрес прописки родителя (опекуна)', currentItem.guardianRegistrationAddress),
        getChangedField(previousItem.deliveryToWhom !== currentItem.deliveryToWhom, 'Кому доставка', currentItem.deliveryToWhom),
        getChangedField(previousItem.deliveryAddress !== currentItem.deliveryAddress, 'Адрес доставки', currentItem.deliveryAddress),
        getChangedField(previousItem.isLearningOutsideMoodle !== currentItem.isLearningOutsideMoodle, 'Обучение вне Moodle', currentItem.isLearningOutsideMoodle),
        getChangedField(previousItem.comment !== currentItem.comment, 'Комментарий', currentItem.comment),
    ].filter(Boolean)

    return <>
        {rows.length > 0 ? rows : <p>Изменения сохранены в карточке договора</p>}
        <p>Нажата кнопка сохранить</p>
    </>
}


/** Вкладка лог журнала */
export const CardContractTabLogs = ({ logsList }: ICardContractTabLogs) => {
    const itemsTimeline: TimelineProps['items'] = logsList.value.map((item, index, list) => {
        const previousItem = list[index + 1]

        return {
            loading: index === 0,
            icon: list.length === (index + 1) ? <IconClock width='18px' height='18px' color='green' /> : undefined,

            title: <>
                <p>{item.logAction === 'INSERT' ? 'Договор создан' : 'Договор изменён'}</p>

                <div>
                    <Flex gap='4px' flexDirection='row' justifyContent='flex-end'>
                        <b>Кем:</b>
                        <p>{item.logOperator || 'Системой'}</p>
                    </Flex>
                </div>

                <Flex gap='4px' flexDirection='row' justifyContent='flex-end'>
                    <b>Когда:</b>
                    <p>{moment(item.logDate).format('DD.MM.YYYY HH:mm:ss')}</p>
                </Flex>
            </>,

            content: <div>
                {item.logAction === 'INSERT'
                    ? 'Договор зарегистрирован'
                    : getActions(previousItem, item)
                }
            </div>
        }
    })

    return <>
        {logsList.value.length === 0
            ? <Empty image={imgEmty} title='Логи отсутствуют' />
            : <Timeline items={itemsTimeline} className='fontStyle' style={{fontWeight: '500'}} />
        }
    </>
}